import dayjs from 'dayjs';

export const PERIODOS = [
    { valor: 'hoje', rotulo: 'Hoje' },
    { valor: 'semana', rotulo: 'Esta semana' },
    { valor: 'mes', rotulo: 'Este mês' },
    { valor: 'mes_anterior', rotulo: 'Mês anterior' },
    { valor: '90d', rotulo: 'Últimos 90 dias' },
    { valor: 'personalizado', rotulo: 'Personalizado' },
];

const F = 'YYYY-MM-DD';

/** Converte a opção de período em { data_inicio, data_fim } (YYYY-MM-DD). */
export function intervalo(periodo, de, ate) {
    const hoje = dayjs();
    switch (periodo) {
        case 'hoje':
            return { data_inicio: hoje.format(F), data_fim: hoje.format(F) };
        case 'semana': {
            // semana de segunda a domingo
            const diasDesdeSegunda = (hoje.day() + 6) % 7;
            const inicio = hoje.subtract(diasDesdeSegunda, 'day');
            return { data_inicio: inicio.format(F), data_fim: inicio.add(6, 'day').format(F) };
        }
        case 'mes_anterior': {
            const m = hoje.subtract(1, 'month');
            return { data_inicio: m.startOf('month').format(F), data_fim: m.endOf('month').format(F) };
        }
        case '90d':
            return { data_inicio: hoje.subtract(89, 'day').format(F), data_fim: hoje.format(F) };
        case 'personalizado':
            if (de && ate && de <= ate) return { data_inicio: de, data_fim: ate };
            return null; // ainda incompleto: não consulta
        case 'mes':
        default:
            return { data_inicio: hoje.startOf('month').format(F), data_fim: hoje.endOf('month').format(F) };
    }
}

export function rotuloPeriodo(periodo, de, ate) {
    if (periodo === 'personalizado') {
        const d = (v) => (v ? dayjs(v).format('DD/MM/YYYY') : '…');
        return `${d(de)} a ${d(ate)}`;
    }
    const p = PERIODOS.find((x) => x.valor === periodo);
    return p ? p.rotulo : '';
}
